// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"Tooltip_tooltipContainer__ucL8l","icon":"Tooltip_icon__2pS1W","tooltip":"Tooltip_tooltip__lJfvi"};